namespace TabAurous.OMS {
    export interface PromotionMasterRow {
        PromoId?: number;
        PromoName?: string;
        PromoType?: string;
        PromoCode?: string;
        ApplicableOn?: number;
        DiscountOn?: string;
        DiscountAmount?: number;
        DiscountPercentage?: number;
        FreeProductId?: number;
        MinimumSalesAmount?: number;
        CodeRequired?: boolean;
        MaximumRedeemCount?: number;
        FromDate?: string;
        ToDate?: string;
        VoucherCode?: string;
        IsDisabled?: boolean;
        IsApproved?: boolean;
        ApprovedBy?: string;
        PromotionDetails?: PromotionDetailsRow[];
    }

    export namespace PromotionMasterRow {
        export const idProperty = 'PromoId';
        export const nameProperty = 'PromoName';
        export const localTextPrefix = 'OMS.PromotionMaster';
        export const deletePermission = 'Masters:Promotion:Delete';
        export const insertPermission = 'Masters:Promotion:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Promotion:Edit';

        export declare const enum Fields {
            PromoId = "PromoId",
            PromoName = "PromoName",
            PromoType = "PromoType",
            PromoCode = "PromoCode",
            ApplicableOn = "ApplicableOn",
            DiscountOn = "DiscountOn",
            DiscountAmount = "DiscountAmount",
            DiscountPercentage = "DiscountPercentage",
            FreeProductId = "FreeProductId",
            MinimumSalesAmount = "MinimumSalesAmount",
            CodeRequired = "CodeRequired",
            MaximumRedeemCount = "MaximumRedeemCount",
            FromDate = "FromDate",
            ToDate = "ToDate",
            VoucherCode = "VoucherCode",
            IsDisabled = "IsDisabled",
            IsApproved = "IsApproved",
            ApprovedBy = "ApprovedBy",
            PromotionDetails = "PromotionDetails"
        }
    }
}
